import { Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/DropdownMenu";
import FilterTrigger from "./FilterTrigger";
import type { GroupByMode } from "../lib/groupProducts";

const MODES: { value: GroupByMode; label: string }[] = [
  { value: "none", label: "None" },
  { value: "product_group", label: "Product group" },
];

interface Props {
  value: GroupByMode;
  onChange: (next: GroupByMode) => void;
}

// "Group by: None ▾" for the Inventory toolbars.
export default function GroupByMenu({ value, onChange }: Props) {
  const current = MODES.find((m) => m.value === value)?.label ?? "None";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterTrigger label="Group by" value={current} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-40">
        {MODES.map((m) => (
          <DropdownMenuItem key={m.value} onSelect={() => onChange(m.value)} className="gap-2 text-xs">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              {m.value === value && <Check className="h-3.5 w-3.5" />}
            </span>
            {m.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
